import { render, staticRenderFns } from "./RefItem.vue?vue&type=template&id=a357e342&"
import script from "./RefItem.vue?vue&type=script&lang=js&"
export * from "./RefItem.vue?vue&type=script&lang=js&"
import style0 from "./RefItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RefItem.vue"
export default component.exports